var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4956 9.16288C12.6518 9.31916 12.7396 9.53108 12.7396 9.75205C12.7396 9.97302 12.6518 10.1849 12.4956 10.3412L8.66807 14.1687C8.51282 14.3209 8.30382 14.4056 8.08646 14.4045C7.8691 14.4034 7.66096 14.3166 7.50726 14.1629C7.35356 14.0092 7.26673 13.801 7.26564 13.5837C7.26454 13.3663 7.34926 13.1573 7.5014 13.002L10.7514 9.75205L7.5014 6.50205C7.34926 6.34681 7.26454 6.1378 7.26564 5.92044C7.26673 5.70309 7.35356 5.49494 7.50726 5.34125C7.66096 5.18755 7.8691 5.10072 8.08646 5.09962C8.30382 5.09852 8.51282 5.18325 8.66807 5.33538L12.4956 9.16288Z",
    fill: "#4C6870"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.ce98474180e63a951ecbe332dfa649cc.svg";
export { ForwardRef as ReactComponent };